<p-tabs [(value)]="activeTab">
  <p-tablist>
    <p-tab value="leistungsgruppen">{{ 'CHOP.TAB_LEISTUNGSGRUPPEN' | translate }}</p-tab>
    <p-tab value="punktekategorien">{{ 'CHOP.TAB_PUNKTEKATEGORIEN' | translate }}</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="leistungsgruppen">
      <app-table
        [actionColumnWidth]="400"
        [columns]="leistungsgruppeColumns"
        [loading]="loading"
        [value]="leistungsgruppen"
        filename="CHOP.LEISTUNGSGRUPPEN"
        sortField="nummer">
        <ng-template
          (onClick)="showCreateLeistungsgruppe()"
          appToolbarButton
          icon="fal fa-plus"
          labelKey="CHOP.CREATE_LEISTUNGSGRUPPE"></ng-template>
        <ng-template
          (onClick)="openLeistungsgruppeDetail($event.row)"
          appActionButton
          icon="fal fa-search"
          labelKey="GLOBAL.DETAILS"></ng-template>
        <ng-template
          (onClick)="showEditLeistungsgruppe($event.row)"
          appActionButton
          icon="fal fa-pencil"
          labelKey="ACTIONS.EDIT"></ng-template>
        <ng-template
          (onClick)="deleteLeistungsgruppe($event.row)"
          appActionButton
          icon="fal fa-trash"
          labelKey="ACTIONS.DELETE"
          type="danger"></ng-template>
      </app-table>
    </p-tabpanel>
    <p-tabpanel value="punktekategorien">
      <app-table
        [actionColumnWidth]="300"
        [columns]="punktekategorieColumns"
        [loading]="loading"
        [value]="punktekategorien"
        filename="CHOP.PUNKTEKATEGORIEN"
        sortField="code">
        <ng-template
          (onClick)="showCreatePunktekategorie()"
          appToolbarButton
          icon="fal fa-plus"
          labelKey="CHOP.CREATE_PUNKTEKATEGORIE"></ng-template>
        <ng-template
          (onClick)="showEditPunktekategorie($event.row)"
          appActionButton
          icon="fal fa-pencil"
          labelKey="ACTIONS.EDIT"></ng-template>
        <ng-template
          (onClick)="deletePunktekategorie($event.row)"
          appActionButton
          icon="fal fa-trash"
          labelKey="ACTIONS.DELETE"
          type="danger"></ng-template>
      </app-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
